/**
 * Validates a link URL against the allowed schemes:
 *  - https://  (any valid HTTPS URL)
 *  - mailto:   (must be followed by a valid email address)
 *
 * Used by both the frontend form validation and the backend Zod schema.
 */
export const isValidLinkUrl = (url: string): boolean => {
  const trimmed = url.trim();
  if (!trimmed) return false;
  if (trimmed.toLowerCase().startsWith('mailto:')) {
    const email = trimmed.slice('mailto:'.length);
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  try {
    return new URL(trimmed).protocol === 'https:';
  } catch {
    return false;
  }
};
